
import axiosInstance from "../../axiosInstance";
import { CreateProjectPayload, CreateProjectApiResponse, ProjectSuccessResponse } from "../../../types/createProject"
import { normalizeApiError } from "../../../utils/normalizeApiError";



export const createProject = async (
  payload: CreateProjectPayload
): Promise<ProjectSuccessResponse> => {
  try {
    const { data } = await axiosInstance.post<CreateProjectApiResponse>(
      "/pmo/create-new-project",
      payload
    );

   if (data?.response?.status === false) {
    const error: any = new Error(data.response.message);
    error.isBusinessError = true;
    throw error;
  }

    return data.response;
  } catch (error:any) {
    if (error.isBusinessError || error.isNetworkError) {
      throw error;
    }
    throw normalizeApiError(error);
  }
};

